/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 我的资产中心概况
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.AssetCenter;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/member/asset-center`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
